import { Fetch } from 'lib';
import { createDiscountCode } from 'services';

type RequestResponses = Awaited<ReturnType<typeof createDiscountCode>>;

type RequestParameters = {
  id: string;
};

type RequestBody = Parameters<typeof createDiscountCode>[number];

const updateDiscountCode = async (
  params: RequestParameters,
  body: RequestBody,
) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminDiscountCode/updateDiscountCode',
    method: 'PUT',
    params,
    body,
  });

export { updateDiscountCode };
